import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Badge.module.scss";

/**
 * Badge / Chip — small caps-heavy label in JetBrains Mono with a tinted
 * background corresponding to status. Used for IDs, revisions, status tags.
 * variant: neutral | info | success | warning | error
 */
export function Badge({ variant = "neutral", mono = true, className, children, ...rest }) {
  return (
    <span
      className={cn(styles.badge, styles[variant], mono && styles.mono, className)}
      {...rest}
    >
      {children}
    </span>
  );
}

Badge.propTypes = {
  variant: PropTypes.oneOf(["neutral", "info", "success", "warning", "error"]),
  mono: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Badge;
